import { atom, createStore } from 'jotai';
import { TErrorMessages } from 'fe-core/src/errors/errorMessages';

export const errorMessagesAtom = atom<TErrorMessages | null>(null);
errorMessagesAtom.debugLabel = 'ErrorMessagesAtom';

export const jotaiStore = createStore();
